"use client";
import { ArtOrderOffer } from "@/api/art-order/types";
import { useMemo } from "react";
import { CommentAuthor } from "../CommentAuthor";
import { ArtOrderPostContent } from "./ArtOrderPostContent";

export interface Props {
  artOrderOffer: ArtOrderOffer;
  paymentErc20TokenAddress: string;
}

export default function ArtOrderPostComment({
  artOrderOffer,
  paymentErc20TokenAddress,
}: Props) {
  const isAcceptedOffer = useMemo(() => {
    const acceptedOfferId = artOrderOffer?.acceptedOrderId;
    const currentOfferId = artOrderOffer.id;

    return acceptedOfferId === currentOfferId;
  }, [artOrderOffer]);

  return (
    <li>
      <div className="flex flex-row w-full justify-between items-center">
        <CommentAuthor
          author={artOrderOffer.author}
          createdAt={artOrderOffer.createdAt}
          showDisplayName
        />
        {isAcceptedOffer ? (
          <label className="bg-green text-body-4-sm font-bold text-white p-2 h-auto rounded-3xl">
            ACCEPTED OFFER
          </label>
        ) : null}
      </div>
      <ArtOrderPostContent
        artOrderOffer={artOrderOffer}
        isAcceptedOffer={isAcceptedOffer}
        paymentErc20TokenAddress={paymentErc20TokenAddress}
      />
    </li>
  );
}
